'use strict';

var angular = require('angular');
module.exports = angular.module('AVRO.Widgets.Listbox', ['jqwidgets']).directive('rmListbox', require('./directives/ListboxDirective'));